export default "__VITE_PUBLIC_ASSET__760e0791__"